<div class="page-body">
  <div class="banner">
    <button type="button" class="back-button" (click)="reroute()">
      <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
      <span class="back-text">Tillbaka</span>
    </button>
  </div>

  <div class="contents-wrapper">
    <div *ngIf="waitFor == 'BANKID'" class="contents-container">
      <div class="page-icon">
        <app-zaver-icon [size]="92" name="bankIDse" ></app-zaver-icon>
      </div>

      <ng-container *ngIf="signingInProgress">
        <span class="status-message">{{ bankIdStatusMessage }}</span>

        <div
          class="qr-container"
          *ngIf="showQrCode"
          [hidden]="!signingInitialized"
        >
          <div class="qr" #canvas></div>
        </div>

        <div
          *ngIf="
            (showQrCode && !signingInitialized) || (!showQrCode && !onDesktop)
          "
        >
          <zaver-loading-dots [color]="'#b7bcc8'"></zaver-loading-dots>
        </div>

        <div
          class="deeplink-button-container"
          *ngIf="!showQrCode && showStartBankIdButton"
        >
          <div class="deeplink-button" (click)="autoStartAppClick()">
            Öppna BankID appen
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!signingInProgress && authErrorMessageList">
        <div class="alert-container">
          <zaver-alert-box
            type="WARNING"
            [messageList]="authErrorMessageList"
          ></zaver-alert-box>
        </div>

        <div class="try-again-button-container">
          <zaver-primary-button
            [text]="tryAgainButtonText"
            (click)="tryAgainClick()"
            [logo]="'assets/icon/BankID-Vector-Logo-White.svg'"
          ></zaver-primary-button>
        </div>
      </ng-container>

      <a
        class="second-option-link"
        (click)="showQrCode ? autoStartAppClick() : showQrCodeClick()"
      >
        <u>{{
          showQrCode ? useThisDeviceButtonText : useDifferentDeviceButtonText
        }}</u>
      </a>
    </div>

    <div *ngIf="waitFor != 'BANKID'" class="contents-container">
      <div class="alert-container">
        <zaver-alert-box type="INFO" [text]="getMessage()"> </zaver-alert-box>
      </div>

      <!-- Never clickable. Only on desktop and displays spinner -->
      <zaver-primary-button
        style="margin-top: 48px"
        *ngIf="onDesktop"
        [text]="'Inväntar svar'"
        [loading]="true"
        [disabled]="true"
      ></zaver-primary-button>
    </div>
  </div>
</div>
